export const sanatoriumFeatures = [
    {
        id: 1,
        bannerText: 'БЕСПЛАТНО', // Текст для функционального баннера
        title: 'Тренажерный зал', // Новый заголовок
        description: 'Современный тренажерный зал со всем необходимым оборудованием для поддержания вашей физической формы и активного образа жизни во время отдыха.', // Новое описание
        imageUrl: '/Assets/Services/Gym.jpg' // Примерный путь к фото
    },
    {
        id: 3,
        bannerText: 'БЕСПЛАТНО',
        title: 'Библиотека Санатория', // Новый заголовок
        description: 'Обширный фонд книг для вашего чтения и отдыха. Более двух тысяч экземпляров.', // Новое описание
        imageUrl: '/Assets/Services/Library.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 4,
        bannerText: 'БЕСПЛАТНО',
        title: 'Комфортабельный Трансфер', // Новый заголовок
        description: 'Организуем вашу поездку с комфортом: встречаем на ж/д вокзале Кисловодска. Наши опытные водители гарантируют безопасность.', // Новое описание
        imageUrl: '/Assets/Services/Transfer.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 5,
        bannerText: 'БЕСПЛАТНО',
        title: 'Лечебная физкультура (ЛФК)', // Новый заголовок
        description: 'Занятия лечебной физкультурой под руководством опытных инструкторов для восстановления и поддержания здоровья.', // Новое описание
        imageUrl: '/Assets/Services/LFK.jpg' // Примерный путь к фото
    },
    {
        id: 6,
        bannerText: 'БЕСПЛАТНО',
        title: 'Крытый Бассейн', // Новый заголовок
        description: 'Насладитесь плаванием в нашем закрытом бассейне. Доступ разрешен для детей от 14 лет.', // Новое описание
        imageUrl: '/Assets/Services/Bassein.jpg' // !!! Укажи реальный путь к фото !!!
    },
    {
        id: 7,
        bannerText: 'ПЛАТНО',
        title: 'Лаборатория', // Новый заголовок
        description: 'Современная лаборатория для проведения различных анализов и исследований, необходимых для диагностики и контроля за вашим здоровьем.', // Новое описание
        imageUrl: '/Assets/Services/Laboratory.jpg' // Примерный путь к фото
    },
];